<template>
  <div class="billing-payment-apm">
    <zm-alert v-if="apmInfo.errorMessage" type="error" show-icon :closable="false" class="payment-method-error">
      <div v-html="apmInfo.errorMessage" />
    </zm-alert>
    <div class="billing-payment-apm__message" v-html="paymentDescription"></div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { APP_NAMESPACE } from '../../store'
import { getApmGaTrackingName } from '../../utils'
import { apmSetInfo } from '../../apis/payment'
import { translateMixins } from '../../plugins/i18n'
import PaymentBase from './common/PaymentBase'
import { APM, APM_UPDATE_PAYMENT_URL } from '../../common/constant'
import { APM_PAYMENT_METHODS } from '../../utils/payment'
import { logger } from '../../utils/log'
import furikomiP24Mixins from './mixins/furikomi-p24-mixin'

export default {
  name: 'APM',
  extends: PaymentBase,
  mixins: [translateMixins, furikomiP24Mixins],
  mounted() {
    this.ready()
  },
  computed: {
    ...mapGetters(APP_NAMESPACE, ['apmInfo', 'soldToAddress', 'billingInfo']),
    getEmail() {
      return this.soldToAddress.email || ''
    },
    apmPaymentMethodName() {
      return this.apmInfo.apmPaymentMethodName
    },
    apmPaymentMethodId() {
      return this.apmInfo.apmPaymentMethodId
    },
    paymentDescription() {
      return this.apmPaymentMethodName ? this.__$t(`billing.payment.${this.apmPaymentMethodName}_desc`) : ''
    },
    tileImageFileName() {
      return this.apmInfo.tileImageFileName
    },
    apmGaTrackingName() {
      return getApmGaTrackingName(this.apmPaymentMethodName, this.tileImageFileName)
    },
    firstName() {
      return this.soldToAddress.firstName || ''
    },
    lastName() {
      return this.soldToAddress.lastName || ''
    },
    zAccountId() {
      return this.billingInfo?.zAccountId || ''
    }
  },
  methods: {
    ...mapMutations(APP_NAMESPACE, ['setApmInfo']),
    async handleSubmit() {
      if (
        this.apmPaymentMethodName === APM_PAYMENT_METHODS.FURIKOMI ||
        this.apmPaymentMethodName === APM_PAYMENT_METHODS.P24
      ) {
        try {
          await this.setupDefaultPaymentMethodForFurikomiAndP24()
        } catch (e) {
          logger.error('error changing default payment method', e)

          this.setApmInfo({
            ...this.apmInfo,
            errorMessage: this.__$t('billing.payment.apm_payment_error')
          })
          return Promise.reject()
        }
        return
      }

      const currentURL = window.location.href
      const redirectUrl = currentURL.replace(window.location.origin, '')

      const payload = JSON.stringify({
        firstName: this.firstName,
        lastName: this.lastName,
        apmName: this.apmPaymentMethodName,
        zmPaymentMethodId: this.apmPaymentMethodId,
        email: this.getEmail,
        zAccountId: this.zAccountId,
        redirectUrl
      })

      try {
        await apmSetInfo({
          payload: {
            jsonString: payload
          }
        })
        window.location.href = `${APM_UPDATE_PAYMENT_URL}?email=${encodeURIComponent(this.getEmail)}`
      } catch (e) {
        this.setApmInfo({
          ...this.apmInfo,
          errorMessage: this.__$t('billing.payment.apm_payment_error')
        })
        return Promise.reject()
      }
    },
    async $submit() {
      try {
        await this.handleSubmit()
      } catch (e) {
        return Promise.reject()
      }
    }
  }
}
</script>

<style lang="scss">
@import '@zoom/billing-responsive/styles/responsive.scss';

.billing-payment-apm {
  &__message {
    margin: 16px 0;
  }

  .payment-method-error {
    margin-top: 16px;
  }
}
</style>
